import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import header_logo from '../../assets/images/Logo.svg';
import header_footerlogo from '../../assets/images/footer-logo.svg';

const Header3 = () => {
    const [isFixed, setIsFixed] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [openDropdown, setOpenDropdown] = useState(null);
    const handleScroll = () => {
        setIsFixed(window.scrollY > 50);
    };
    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
        document.body.classList.toggle("mobile-menu-open", !isMenuOpen);
    };
    const toggleDropdown = (index) => {
        setOpenDropdown(openDropdown === index ? null : index);
    };


    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return (
        <>
            <header className={isFixed ? "main-header header-three sticky-header--cloned sticky-fixed " : 'main-header header-three'} style={{ bgcolor: 'rgba(213, 219, 226, 0.91)' }}>
                <div className="container">
                    <nav className="main-menu">
                        <div className="main-menu-logo">
                            <Link to="/">
                                <img src={header_footerlogo} alt="header-logo" />
                            </Link>
                        </div>
                        <div className="main-menu-inner">
                            <ul className="main-menu-list">
                                <li className="menu-item-children active">
                                    <Link href="#">Home</Link>
                                    <i className="fa-solid fa-chevron-down" />
                                    <ul>
                                        <ul>
                                            <li>
                                                <Link to="/">Home One</Link>
                                            </li>
                                            <li>
                                                <Link to="/HomeTwo">Home Two</Link>
                                            </li>
                                            <li>
                                                <Link to="/HomeThree">Home Three</Link>
                                            </li>
                                            <li>
                                                <Link to="/HomeFour">Home Four</Link>
                                            </li>
                                            <li>
                                                <Link to="/HomeFive">Home Five</Link>
                                            </li>
                                        </ul>
                                    </ul>
                                </li>
                                <li className="menu-item-children">
                                    <Link to="#">Pages</Link>
                                    <i className="fa-solid fa-chevron-down" />
                                    <ul>
                                        <li>
                                            <Link to="/Aboutus">About Us</Link>
                                        </li>
                                        <li>
                                            <Link to="/Careers">Careers</Link>
                                        </li>
                                        <li>
                                            <Link to="/Team">Meet The Team</Link>
                                        </li>
                                        <li>
                                            <Link to="/Testimonial">Testimonial</Link>
                                        </li>
                                        <li>
                                            <Link to="/Pricing">Pricing</Link>
                                        </li>
                                    </ul>
                                </li>
                                <li className="menu-item-children">
                                    <Link to="#">Services</Link>
                                    <i className="fa-solid fa-chevron-down" />
                                    <ul>
                                        <li>
                                            <Link to="/Services">Services </Link>
                                        </li>
                                        <li>
                                            <Link to="/ServiceDetails">Services Details</Link>
                                        </li>
                                    </ul>
                                </li>
                                <li className="menu-item-children">
                                    <Link to="#">Portfolio</Link>
                                    <i className="fa-solid fa-chevron-down" />
                                    <ul>
                                        <li>
                                            <Link to="/Portfolio">Portfolio</Link>
                                        </li>
                                        <li>
                                            <Link to="/Details">Portfolio Details</Link>
                                        </li>
                                    </ul>
                                </li>
                                <li className="menu-item-children">
                                    <Link to="#">Blog</Link>
                                    <i className="fa-solid fa-chevron-down" />
                                    <ul>
                                        <li>
                                            <Link to="/Blog">Blog Standard</Link>
                                        </li>
                                        <li>
                                            <Link to="/BlogDetails">Blog Details</Link>
                                        </li>
                                    </ul>
                                </li>
                                <li className="menu-item-children">
                                    <Link to="#">Shop</Link>
                                    <i className="fa-solid fa-chevron-down" />
                                    <ul>
                                        <li>
                                            <Link to="/Shop">Shop</Link>
                                        </li>
                                        <li>
                                            <Link to="/ProdectDetails">Product Details</Link>
                                        </li>
                                        <li>
                                            <Link to="/Cart">Cart</Link>
                                        </li>
                                        <li>
                                            <Link to="/Checkout">Checkout</Link>
                                        </li>
                                    </ul>
                                </li>
                                <li className="menu-item-children">
                                    <Link to="/Contact">Contact Us</Link>
                                </li>
                            </ul>
                            <div className="header-menu-collaps" onClick={toggleMenu}>
                                <span className="line-1" />
                                <span className="line-2" />
                                <span className="line-3" />
                            </div>
                            <div className={`mobile-nav-wrapper ${isMenuOpen ? "expanded" : ""}`}>

                                <div className="mobile-nav-overlay" onClick={toggleMenu}></div>
                                <div className="mobile-nav-content">
                                    <button className="mobile-nav-close" onClick={toggleMenu} style={{ background: "none", fontSize: 50, border: "none", position: "fixed", top: 10, color: "#fff" }} >
                                        ×
                                    </button>
                                    <div className="logo-box">
                                        <Link to="/">
                                            <img width="150" src={header_logo} alt="logo" />
                                        </Link>
                                    </div>
                                    <div className="mobile-nav-container">
                                        <ul className="mobile-menu-list">

                                            <li className={`menu-item-has-children ${openDropdown === 1 ? "dropdown-open" : ""}`}>
                                                <Link to="#" onClick={() => toggleDropdown(1)}>Home <i className="fa-solid fa-chevron-down" /></Link>
                                                {openDropdown === 1 && (
                                                    <ul>
                                                        <li><Link to="/">Home-1</Link></li>
                                                        <li><Link to="/HomeTwo">Home-2</Link></li>
                                                        <li><Link to="/HomeThree">Home-3</Link></li>
                                                        <li><Link to="/HomeFour">Home-4</Link></li>
                                                        <li><Link to="/HomeFive">Home-5</Link></li>
                                                    </ul>
                                                )}
                                            </li>
                                            <li className={`menu-item-has-children ${openDropdown === 2 ? "dropdown-open" : ""}`}>
                                                <Link to="#" onClick={() => toggleDropdown(2)}>Pages <i className="fa-solid fa-chevron-down" /></Link>
                                                {openDropdown === 2 && (
                                                    <ul>
                                                        <li><Link to="/Aboutus">About Us</Link></li>
                                                        <li><Link to="/Careers">Careers</Link></li>
                                                        <li><Link to="/Team">Meet The Team</Link></li>
                                                        <li><Link to="/Testimonial">Testimonial</Link></li>
                                                        <li><Link to="/Pricing">Pricing</Link></li>
                                                    </ul>
                                                )}
                                            </li>
                                            <li className={`menu-item-has-children ${openDropdown === 3 ? "dropdown-open" : ""}`}>
                                                <Link to="#" onClick={() => toggleDropdown(3)}>Services <i className="fa-solid fa-chevron-down" /></Link>
                                                {openDropdown === 3 && (
                                                    <ul>
                                                        <li><Link to="/Services">Services</Link></li>
                                                        <li><Link to="/ServiceDetails">Service Details</Link></li>
                                                    </ul>
                                                )}
                                            </li>
                                            <li className={`menu-item-has-children ${openDropdown === 4 ? "dropdown-open" : ""}`}>
                                                <Link to="#" onClick={() => toggleDropdown(4)}>Portfolio <i className="fa-solid fa-chevron-down" /></Link>
                                                {openDropdown === 4 && (
                                                    <ul>
                                                        <li><Link to="/Portfolio">Portfolio</Link></li>
                                                        <li><Link to="/Details">Portfolio Details</Link></li>
                                                    </ul>
                                                )}
                                            </li>
                                            <li className={`menu-item-has-children ${openDropdown === 5 ? "dropdown-open" : ""}`}>
                                                <Link to="#" onClick={() => toggleDropdown(5)}>Blog <i className="fa-solid fa-chevron-down" /></Link>
                                                {openDropdown === 5 && (
                                                    <ul>
                                                        <li><Link to="/Blog">Blog Standard</Link></li>
                                                        <li><Link to="/BlogDetails">Blog Details</Link></li>
                                                    </ul>
                                                )}
                                            </li>
                                            <li className={`menu-item-has-children ${openDropdown === 6 ? "dropdown-open" : ""}`}>
                                                <Link to="#" onClick={() => toggleDropdown(6)}>Shop <i className="fa-solid fa-chevron-down" /></Link>
                                                {openDropdown === 6 && (
                                                    <ul>
                                                        <li><Link to="/Shop">Shop</Link></li>
                                                        <li><Link to="/ProductDetails">Product Details</Link></li>
                                                        <li><Link to="/Cart">Cart</Link></li>
                                                        <li><Link to="/Checkout">Checkout</Link></li>
                                                    </ul>
                                                )}
                                            </li>
                                            <li>
                                                <Link to="/Contact">Contact Us</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="main-menu-right">
                            <Link to="/Contact" className="btn btn-light btn-theme">
                                Get In Touch <span>+</span>
                            </Link>
                        </div>
                    </nav>
                </div>
            </header>

        </>
    )
}

export default Header3
